import React, { useCallback, useState, useEffect } from "react";
import MstService from "../../../services/mst.service";
import requestAndErrorHandler from "../../../services/responseAndErrorHandler";
import {
  Row,
  Col,
  Form
} from "react-bootstrap";
import TokenService from "../../../services/token.service";
import VARIABLES from "../../../services/variable.service";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import FileSaver from "file-saver";
import { EXPENSE_EXCEL_FILE_BASE64 } from "../../../services/sample_file";
import LayoutContainer from "../../../FUSComponents/LayoutContainer/LayoutContainer";
import { FUSButton } from "../../../FUSComponents/FUSElements/FUSButton/FUSButton";
import "./ViewExpense.css";
import FUSModal from "../../../FUSComponents/FUSModal/FUSModal";
import FUSUploadFile from "../../../FUSComponents/FUSElements/FUSUploadFile/FUSUploadFile";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";

function ViewExpense() {
  const [expensedata, setExpenseData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [toggleModal, setToggleModal] = useState({
    state: false,
    type: null,
  });

  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteRow, setDeleteRow] = useState({});
  const [formData, setFormData] = useState({
    expense_type: "",
    is_active: "",
    type: "ALL",
  });

  const getExpenseData = () => {
    MstService.crudExpense({
      type: "ALL",
    })
      .then((res) => {
        if (res?.data?.errorCode === 0) {
          setExpenseData(res?.data?.data);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };
  useEffect(() => {
    getExpenseData();
  }, [isLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const expenseModal = () => {
    setFormData((prevData) => ({
      ...prevData,
      type: "INSERT",
    }));

    setToggleModal((prev) => ({ ...prev, state: true, type: "editGodown" }));
  };

  const handleClose = () => {
    setFormData({
      type_name: "",
      type: "ALL",
      is_active: "",
    });
    setIsEdit(false);
    setToggleModal((prev) => ({ ...prev, state: false }));
    setSelectedFile();
    setIsFilePicked(false);
  };

  const handleDeleteModal = (item) => {
    setToggleModal((prev) => ({ ...prev, state: true, type: "delete" }));
  };
  const addNewExpense = () => {
    setIsEdit(false);
    MstService.crudExpense(formData)
      .then((res) => {
        if (res?.data?.errorCode === 0) {
          setToggleModal((prev) => ({ ...prev, state: false }));
          setIsLoading((isLoading) => !isLoading);
          const successToast = toast.success(
            `${res?.data?.message}`,
            { position: "bottom-left", autoClose: false }
          );
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
    setFormData({
      type_name: "",
      type: "ALL",
      is_active: "",
    });
  };

  const handleDownload = () => {
    let sliceSize = 1024;
    let byteCharacters = atob(EXPENSE_EXCEL_FILE_BASE64);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    FileSaver.saveAs(
      new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
      "sample_expense_file.xlsx"
    );
  };

  const handleEditClick = (row) => {
    setIsEdit(true);
    MstService.crudExpense({ type: "GET", id: row.id })
      .then((res) => {
        setFormData(res?.data?.data[0]);
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const handleEditExpense = () => {
    MstService.crudExpense({ ...formData, type: "UPDATE" })
      .then((res) => {
        if (res?.data?.errorCode === 0) {
          setIsEdit(false);
          setToggleModal((prev) => ({ ...prev, state: false }));
          setFormData({
            dept_name: "",
            type: "ALL",
            is_active: "",
          });
          setIsLoading((isLoading) => !isLoading);

          const successToast = toast.success(
            `${res?.data?.message}`,
            { position: "bottom-left", autoClose: false }
          );
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const handleDelete = () => {
    MstService.crudExpense({ id: deleteRow.id, type: "DELETE" })
      .then((response) => {
        if (
          response?.data?.errorCode === 201 ||
          response?.data?.errorCode === 200 ||
          response?.data?.errorCode === 0
        ) {
          setExpenseData((oldValues) => {
            return oldValues.filter((item) => item.id !== deleteRow.id);
          });
          const successToast = toast.success(
            `${response?.data?.message}`,
            { position: "bottom-left", autoClose: false }
          );
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
          setDeleteRow({});
          setToggleModal((prev) => ({ ...prev, state: false }));
        }
        if (
          response?.data?.errorCode === -101 ||
          response?.data?.errorCode === -102 ||
          response?.data?.errorCode === -103 ||
          response?.data?.errorCode === -100
        ) {

          const successToast = toast.success(
            `${response?.data?.message}`,
            { position: "bottom-left", autoClose: false }
          );
          setTimeout(() => {
            toast.dismiss(successToast);
          }, 2000);
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  // for handling excel upload

  const changeHandler = (event) => {
    if (event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
      setIsFilePicked(true);
    } else {
      setIsFilePicked(false);
    }
  };

  const handleSubmission = () => {
    const fileExt = selectedFile?.name.substring(
      selectedFile?.name.lastIndexOf(".")
    );
    if (fileExt === ".xlsx" || fileExt === ".xls") {
      var confirm = window.confirm(
        "PLease ensure your file constains expenses !"
      );
      if (!confirm) {
        setIsLoading((loadingValue) => !loadingValue);
      } else {
        uploadData(false);
      }
    } else {
      const successToast = toast.success(
        "Please Upload a Excel file",
        { position: "bottom-left", autoClose: false }
      );
      setTimeout(() => {
        toast.dismiss(successToast);
      }, 2000);
    }
  };
  const uploadData = (overrides) => {
    const token = TokenService.getLocalAccessToken();
    const strURL = `${VARIABLES.BASE_URL}importExpenseByExcel`;
    const formData = new FormData();
    formData.append("uploadfile", selectedFile);

    axios({
      method: "post",
      url: strURL,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data;`,
        Authorization: "Bearer " + token,
      },
    })
      .then((response) => {
        if (response?.data?.errorCode === -444) {
          setIsFilePicked(false);
          setSelectedFile();
        } else {
          let text = response?.data?.message;
          if (window.confirm(text) === true) {
            setSelectedFile();
            setIsFilePicked(false);
            setIsLoading(!isLoading);
          }
        }
      })
      .catch((error) => {
        requestAndErrorHandler.errorHandler(error);
      });
  };

  const columns = [
    {
      dataField: "expense_type",
      text: "Type Of Expense",
    },
    {
      dataField: "remove",
      text: "Status",
      formatter: (cellContent, row) => {
        return (
          <>
            {row?.is_active ? (
              <span className="text-success">Active</span>
            ) : (
              <span className="text-danger">Inactive</span>
            )}
          </>
        );
      },
      editable: false,
    },

    {
      dataField: "remove",
      text: "Action",
      formatter: (cellContent, row) => {
        return (
          <>
            <div className="d-flex gap-3">
              <div>
                <FUSButton
                  className={"action_button_style"}
                  iconSrc="md"
                  iconName="MdOutlineModeEdit"
                  iconSize={15}
                  buttonType="lightgray"
                  onClick={() => {
                    setToggleModal((prev) => ({
                      ...prev,
                      state: true,
                      type: "editGodown",
                    }));
                    handleEditClick(row);
                  }}
                />
              </div>
              <div>
                <FUSButton
                  className={"action_button_style"}
                  iconSrc="md"
                  iconName="MdDeleteForever"
                  iconSize={15}
                  buttonType="lightdanger"
                  onClick={() => {
                    handleDeleteModal(row);
                    setDeleteRow(row);
                  }}
                />
              </div>
            </div>
          </>
        );
      },
      editable: false,
    },
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );
  const options = {
    paginationSize: 4,
    pageStartIndex: 0,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "7",
        value: 7,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "All",
        value: expensedata.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };


  const isMobile = useMediaQuery({ minWidth: 200, maxWidth: 576 })

  return (
    <>
      <LayoutContainer
        title1={"Settings"}
        title2={"Settings"}
        title3={"Expense"}
        right={
          <>
            <div className="d-flex text-center pt-1 align-items-center">
              <span className="beat_file_sample d-none d-sm-block">Upload expense file in</span>
              &nbsp;
              <a
                className="beat_file_sample themeColorBlue"
                style={{ cursor: "pointer" }}
                onClick={handleDownload}
              >
                Link sample expense format file
              </a>
            </div>
          </>
        }
      >
        <div className="px-1 py-2">
          <div className="border_bottom_color">
            <div className="row ">
              <div className="col-12 d-flex justify-content-sm-end gap-3">
                <FUSButton
                  iconSrc={"fa6"}
                  iconName={"FaPlus"}
                  iconSize={14}
                  labelText={isMobile ? "Expense Type" : "Add Expense Type"}
                  buttonType="secondary"
                  onClick={expenseModal}
                />

                <FUSButton
                  iconSrc={"md"}
                  iconName={"MdOutlineFileDownload"}
                  iconSize={19}
                  labelText={isMobile ? "Expense Type" : "Import Expense Type"}
                  buttonType="primary"
                  onClick={() =>
                    setToggleModal((prev) => ({
                      ...prev,
                      state: true,
                      type: "",
                    }))
                  }
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-start mt-1 px-2 pb-5 mb-5 ">
            <div className="col-lg-11 col-12 px-1">
              <BootstrapTable
                classes="border border-1"
                keyField="id"
                data={expensedata}
                columns={columns}
                sizePerPage={5}
                filter={filterFactory()}
                pagination={paginationFactory(options)}
              />
            </div>
          </div>

          {toggleModal.state ? (
            <FUSModal
              title={
                toggleModal.type == "delete"
                  ? `Delete Expense`
                  : toggleModal.type == "editGodown"
                    ? `${isEdit ? "Edit Expense Details" : "Add Expense Details"}`
                    : `${!isEdit ? "Add Expense Details" : "Edit Expense Details"
                    }`
              }
              showModal={toggleModal.state}
              size={"md"}
              handleClose={() => handleClose(false)}
              centered
            >
              {toggleModal.type == "delete" ? (
                <div>
                  <span className="text-danger fs-5">
                    Do you want to delete this expense ?
                  </span>
                  <FUSButton
                    className={"form-control mt-3"}
                    buttonType="primary"
                    onClick={() => handleDelete()}
                    labelText={"Save Changes"}
                  />
                </div>
              ) : toggleModal.type == "editGodown" ? (
                <>
                  <Form>
                    <Row>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationCustom03"
                        className="mx-0 px-0"
                      >
                        <div>
                          <span className="label_style">New Expense</span>
                          <Form.Control
                            className="py-2 my-1 text_style"
                            onChange={handleChange}
                            type="text"
                            value={formData.expense_type}
                            name="expense_type"
                            placeholder="Enter here"
                          />
                        </div>
                        {isEdit && (
                          <div>
                            <span className="label_style">Status</span>
                            <Form.Select
                              className="py-2 my-1 text_style"
                              name="is_active"
                              value={formData.is_active}
                              onChange={handleChange}
                            >
                              <option value="true">Activate</option>
                              <option value="false">Deactivate </option>
                            </Form.Select>
                          </div>
                        )}
                      </Form.Group>
                    </Row>
                    <div className="mt-3">
                      {formData.expense_type &&
                        formData.expense_type !== "" &&
                        formData.expense_type !== null &&
                        formData.expense_type !== undefined ? (
                        <FUSButton
                          className={"form-control"}
                          buttonType="primary"
                          onClick={isEdit ? handleEditExpense : addNewExpense}
                          labelText={"Save Changes"}
                        />
                      ) : null}
                    </div>
                  </Form>
                </>
              ) : (
                <>
                  <Form>
                    <div>
                      <div className="row d-flex justify-content-center mt25">
                        <div className="col-lg-auto">
                          <Form.Group controlId="formFileLg" className="mb-3">
                            <FUSUploadFile
                              title="Upload Expanse"
                              onChange={changeHandler}
                            />
                            <div className="row-bottom-margin mt25">
                              {isFilePicked && (
                                <Form.Group as={Col}>
                                  <Form.Label>
                                    {isFilePicked ? (
                                      <div>
                                        <p className="p0">
                                          {`Filename: ${selectedFile?.name} `}{" "}
                                        </p>
                                        <p className="p0">
                                          {`  Filetype: ${selectedFile?.type} `}{" "}
                                        </p>
                                        <p className="p0">
                                          {`  Size in bytes: ${selectedFile?.size}`}{" "}
                                        </p>
                                        <p className="p0">
                                          {`  lastModifiedDate: ${selectedFile?.lastModifiedDate.toLocaleDateString()} `}{" "}
                                        </p>
                                      </div>
                                    ) : (
                                      <span>Select a file to show details</span>
                                    )}
                                  </Form.Label>

                                  <FUSButton
                                    className={"form-control mt-3"}
                                    buttonType="primary"
                                    labelText={"Upload"}
                                    onClick={handleSubmission}
                                  />
                                </Form.Group>
                              )}
                            </div>
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                    <div>
                      {formData.expense_type &&
                        formData.expense_type !== "" &&
                        formData.expense_type !== null &&
                        formData.expense_type !== undefined ? (
                        <FUSButton
                          className={"form-control"}
                          buttonType="primary"
                          onClick={isEdit ? handleEditExpense : addNewExpense}
                          labelText={"Save Changes"}
                        />
                      ) : null}
                    </div>
                  </Form>
                </>
              )}
            </FUSModal>
          ) : null}
        </div>
      </LayoutContainer>
    </>
  );
}

export default ViewExpense;
